import api from '../../api/api'

const state = {
  all: []
}

// getters
const getters = {}

// actions
const actions = {
  getAllStreets ({ commit }) {
    api.getStreets(streets => {
      commit('setStreets', streets)
    })
  },
  updateStreet (context, street) {
    api.updateStreet(street.id, street, function () {
      context.commit('getAllStreets')
    })
  },
  delStreet (context, street) {
    api.deleteStreet(street, function () {
      context.commit('getAllStreets')
    })
  },
  addStreet (context, street) {
    return api.addStreet(street, function (data) {
      context.commit('getAllStreets')
    })
  }
}
const mutations = {
  getAllStreets (state, options) {
    this.dispatch('getAllStreets', options)
  },
  setStreets (state, streets) {
    state.all = streets
  },
  updateStreet (state, options) {
    this.dispatch('updateStreet', options)
  },
  delStreet (state, options) {
    this.dispatch('delStreet', options)
  },
  addStreet (state, options) {
    this.dispatch('addStreet', options)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/streets.js